module.exports = __webpack_public_path__ + "img/TK.6d4919f6.svg";